import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { WebApiService } from '../service/web-api.service';

@Injectable()
export class ResetPasswordService {

  constructor(private webApiServece: WebApiService) { }

  /**
   * メールアドレスに認証メール送信
   * @param mailAddress メールアドレス
   * @param screenId 画面ID
   * @param pageNo 次ページ番号
   * @param nextParameter 認証URLから遷移する先のページに引き継ぐ情報（JSON形式）
   */
  execAuthSendMail(mailAddress: string, screenId: string, pageNo: number, nextParameter: string): Observable<any[]> {
    const requestParam = {
      'mail_address': mailAddress,
      'check': 'exist+lock',
      'screen_id': screenId,
      'page_no': pageNo,
      'next_parameter': nextParameter
    };
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/auth-send-mail', requestParam)
      .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (! data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
          return Observable.throw(error);
      });
  }

  /**
   * メール認証チェック
   *
   */
  execAuthCheckMail(): Observable<any[]> {
    const requestParam = {};
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/auth-check-mail', requestParam)
      .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (! data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
          return Observable.throw(error);
      });
  }

  /**
   * 削除すべきリソースの確認
   */
  execAuthShouldResetResource() {
    const requestParam = {};
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/should-reset-resource', requestParam)
    .map(cfResponse => {
      return cfResponse.data;
    })
    .catch(error => {
        return Observable.throw(error);
    });
  }

  /**
   * パスワードリセット
   * @param mailAddress メールアドレス
   * @param newPassword 新しいパスワード
   * @param confirmPassword 確認用パスワード
   */
  execAuthResetPassword(mailAddress: string, newPassword: string, confirmPassword: string): Observable<any[]> {
    const requestParam = { 'mail_address': mailAddress, 'new_password': newPassword, 'confirm_password': confirmPassword };
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/auth-reset-password', requestParam)
    .map(cfResponse => {
      const data = cfResponse.data;
      // NGの場合はメッセージ、正常の場合はnullを返却
      if (! data.result) {
        return data.messages;
      }
      return null;
    })
    .catch(error => {
        return Observable.throw(error);
    });
  }
}
